export default __webpack_public_path__ + "static/media/NotoSansKR-Regular.b1db0fdc.woff2";